import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import whatsappQr from "@/assets/whatsapp-qr.jpg.asset.json";
import lineQr from "@/assets/line-qr.jpg.asset.json";

const WhatsAppChat = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="fixed bottom-6 right-6 z-50 animate-fade-in hidden md:block">
        <div className="group relative">
          <button
            type="button"
            onClick={() => setOpen(true)}
            className="inline-flex items-center justify-center h-16 w-16 rounded-full shadow-elegant hover:shadow-glow transition-all duration-300 bg-[#25D366] hover:bg-[#20bd5a] text-white"
            aria-label={t("whatsapp.tooltip", "Contact us on WhatsApp or LINE")}
          >
            <MessageCircle className="h-7 w-7 group-hover:scale-110 transition-transform" />
          </button>
          <div className="absolute bottom-full right-0 mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
            <div className="bg-foreground text-background px-3 py-2 rounded-lg text-sm whitespace-nowrap shadow-elegant">
              {t("whatsapp.tooltip", "Contact us on WhatsApp or LINE")}
            </div>
          </div>
        </div>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="font-serif text-2xl tracking-wider text-primary">
              {t("whatsapp.modalTitle", "Contact Siam Horizon")}
            </DialogTitle>
            <DialogDescription className="font-body">
              {t(
                "whatsapp.modalDescription",
                "Scan a QR code with your phone to start a chat."
              )}
            </DialogDescription>
          </DialogHeader>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-2">
            <figure className="flex flex-col items-center gap-3">
              <img
                src={whatsappQr.url}
                alt="WhatsApp QR code to chat with Siam Horizon Hua Hin"
                width={400}
                height={400}
                loading="lazy"
                className="w-full max-w-[220px] rounded-lg border border-border object-contain bg-white"
              />
              <figcaption className="font-body text-xs tracking-widest uppercase text-muted-foreground">
                WhatsApp
              </figcaption>
            </figure>
            <figure className="flex flex-col items-center gap-3">
              <img
                src={lineQr.url}
                alt="LINE QR code to chat with Siam Horizon Hua Hin"
                width={400}
                height={400}
                loading="lazy"
                className="w-full max-w-[220px] rounded-lg border border-border object-contain bg-white"
              />
              <figcaption className="font-body text-xs tracking-widest uppercase text-muted-foreground">
                LINE
              </figcaption>
            </figure>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default WhatsAppChat;
